<template>
    <div class="caja-container">
        <div class="datos-suceso-detalle">
            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.nombre_oscilo') }} </label>
                <span>{{ suceso.NombreOscilo }}</span>
            </div>

            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.fecha_hora') }} </label>
                <span>{{ fechaHoraString }}</span>
            </div>

            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.nombre_suceso_tipo') }} </label>
                <span>{{ suceso.NombreSucesoTipo }}</span>
            </div>

            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.nombre_suceso_categoria_tipo') }} </label>
                <span>{{ suceso.NombreSucesoCategoriaTipo }}</span>
            </div>

            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.tiene_fichero_medidas') }} </label>
                <span>{{ suceso.TieneFicheroMedidas ? $t("shared.ui.buttons.yes") : $t("shared.ui.buttons.no")}}</span>
            </div>

            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.tiene_adjuntos') }} </label>
                <span>{{ suceso.TieneAdjuntos  ? $t("shared.ui.buttons.yes") : $t("shared.ui.buttons.no") }}</span>
            </div>

            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.wiki') }} </label>
                <span>{{ suceso.Wiki  ? $t("shared.ui.buttons.yes") : $t("shared.ui.buttons.no") }}</span>
            </div>

            <div class="campo-datos">
                <label>{{ $t('sucesos.cajita_sucesos.comentarios') }} </label>
                <span>{{ suceso.Comentarios }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import type { SucesoDetalleModel } from '@/.shared/.api';
import { standardFormatDate } from '@/.shared/helpers/date-helper';

const props = defineProps<{ sucesoProp: SucesoDetalleModel }>();
const suceso = computed(() => props.sucesoProp);

const fechaHoraString = computed(() => {
    const fechaHora = suceso.value.FechaHora;
    const codigoZonaHorariaInstalacion = suceso.value.CodigoZonaHorariaInstalacion;
    return standardFormatDate(fechaHora, codigoZonaHorariaInstalacion);
});

</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";


.caja-container {
    display: flex;
    position: relative;
    overflow: hidden;
    padding: var(--spacing-md);
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-xs);
    flex: 1 0 0;
    border-radius: var(--ui-oscilo-card-radius);
    background: var(--background-default-default);
    box-shadow: 0px 4px 4px 0px rgba(36, 36, 36, 0.10);
}

.datos-suceso-detalle {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: var(--spacing-xs);
    grid-auto-rows: max-content;
    width: 100%;
}

.campo-datos label,
.campo-datos span {
    display: block;
    line-height: var(--line-height-body-md);
}
</style>